<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-view">
    <!-- <vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
      <span>User record with id: {{ $route.params.userId }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'page-user-list'}" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert> -->
    <div id="user-data">
      <!-- {{"Permissao adicionar "+canAddEmp}} -->
      <vx-card class="mb-base" title="Filtros">
        <div class="vx-row">
          <div class="vx-col w-1/4 mb-5">
            <label for="">Data de entrada</label>
            <vs-input
              @change="getEmployees"
              class="w-full"
              icon-pack="feather"
              icon-no-border
              v-model="entry_date"
              type="date"
              v-validate="'required'"
            />
          </div>
          <div class="vx-col w-1/4 mb-5">
            <label for="">Nome</label>
            <v-select
              v-validate="'required'"
              v-model="name"
              :options="func"
              label="name"
            >
            </v-select>
          </div>
          <div class="vx-col w-1/4 mb-5">
            <label for="">Apelido</label>
            <v-select
              v-validate="'required'"
              v-model="surname"
              :options="func"
              label="surname"
            >
            </v-select>
          </div>
          <div class="vx-col w-1/4 mb-5">
            <label for="">Observação</label>
            <v-select
              v-validate="'required'"
              v-model="note"
              :options="[
                'presente',
                'ausente',
                'folga',
                'licença',
                'justificada com compesação',
                'justificada sem compesação',
              ]"
            >
            </v-select>
          </div>

          <div class="vx-col w-full">
            <div class="mt-8 flex flex-wrap items-center justify-end">
              <label for=""></label> <br />
              <vs-button class="" color="primary" @click="getEmployees"
                >Filtrar</vs-button
              >
            </div>
          </div>
          <!-- <div class="vx-col w-1/6  mb-5" >
             <label for=""></label> <br>
              <vs-button  class="w-full" color="primary"  @click="saveMarcar">
                Marcar
              </vs-button>
              
          </div> -->
        </div>
        <!-- Avatar -->
      </vx-card>

      <vx-card title="">
        <vs-divider></vs-divider>
        <div class="block overflow-x-auto">
          <vs-table stripe :max-items="paginate" search :data="employees">
            <template slot="header">
              <select
                @change="getEmployees"
                class="block ml-3 pl-3 pr-10 py-2 transition duration-100 ease-in-out border rounded shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed"
                v-validate="'excluded:1,2,3'"
                v-model="paginate"
                name="not_in_field"
                data-vv-as="selected"
              >
                <option class="vs__selected-options" value="5">5</option>
                <option class="vs__selected-options" value="10">10</option>
                <option class="vs__selected-options" value="15">20</option>
                <option class="vs__selected-options" value="50">50</option>
                <option class="vs__selected-options" value="100">100</option>
                <option class="vs__selected-options" value="500">500</option>
                <option class="vs__selected-options" value="1000">1000</option>
              </select>
            </template>
            <template slot="thead">
              <vs-th sort-key="name">Nome</vs-th>
              <vs-th sort-key="surname">Apelido</vs-th>
              <vs-th sort-key="entry_date">Data</vs-th>
              <vs-th sort-key="entry_date">Hora de entrada</vs-th>
              <vs-th sort-key="entry_date">Hora de Saida</vs-th>

              <vs-th sort-key="entry_date">Atrazo</vs-th>
              <vs-th sort-key="entry_date">Observação</vs-th>
              <vs-th></vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].name">
                  {{ data[indextr].name }}
                </vs-td>

                <vs-td :data="data[indextr].surname">
                  {{ data[indextr].surname }}
                </vs-td>
                <vs-td :data="data[indextr].date">
                  {{ data[indextr].date }}
                </vs-td>
                <vs-td>
                  <span v-if="data[indextr].entry_date">
                    {{ data[indextr].entry_date.slice(10) }}
                  </span>
                  <span class="font-bold whitespace-no-wrap" v-else>
                    Sem marcação
                  </span>
                </vs-td>

                <vs-td>
                  <span v-if="data[indextr].exit_date">
                    {{ data[indextr].exit_date.slice(10) }}
                  </span>
                  <span class="font-bold whitespace-no-wrap" v-else>
                    Sem marcação
                  </span>
                </vs-td>

                <vs-td :data="data[indextr].delay">
                  {{ data[indextr].delay }}
                </vs-td>
                <vs-td>
                  <vs-chip
                    v-if="data[indextr].note == 'presente'"
                    class="font-bold whitespace-no-wrap"
                    :data="data[indextr].note == 'presente'"
                  >
                    <div
                      class="h-2 w-2 rounded-full mr-1"
                      :class="'bg-success'"
                    ></div>
                    <span>{{ data[indextr].note }}</span>
                  </vs-chip>

                  <vs-chip
                    v-if="data[indextr].note == 'ausente'"
                    class="font-bold"
                    :data="data[indextr].note == 'ausente'"
                  >
                    <div
                      class="h-2 w-2 rounded-full mr-1"
                      :class="'bg-danger'"
                    ></div>
                    <span>{{ data[indextr].note }}</span>
                  </vs-chip>

                  <vs-chip
                    v-if="data[indextr].note == 'justificada sem compesação'"
                    class="font-bold whitespace-no-wrap"
                    :data="data[indextr].note == 'justificada sem compesação'"
                  >
                    <div
                      class="h-2 w-2 rounded-full mr-1"
                      :class="'bg-warning'"
                    ></div>
                    <span>{{ data[indextr].note }}</span>
                  </vs-chip>
                  <vs-chip
                    v-if="data[indextr].note == 'justificada com compesação'"
                    class="font-bold whitespace-no-wrap"
                    :data="data[indextr].note == 'justificada sem compesação'"
                  >
                    <div
                      class="h-2 w-2 rounded-full mr-1"
                      :class="'bg-primary'"
                    ></div>
                    <span>{{ data[indextr].note }}</span>
                  </vs-chip>
                  <vs-chip
                    v-if="data[indextr].note == 'licença'"
                    class="font-bold whitespace-no-wrap"
                    :data="data[indextr].note == 'licença'"
                  >
                    <div
                      class="h-2 w-2 rounded-full mr-1"
                      :class="'bg-primary'"
                    ></div>
                    <span>{{ data[indextr].note }}</span>
                  </vs-chip>
                  <vs-chip
                    v-if="data[indextr].note == 'férias'"
                    class="font-bold whitespace-no-wrap"
                    :data="data[indextr].note == 'férias'"
                  >
                    <div
                      class="h-2 w-2 rounded-full mr-1"
                      :class="'bg-primary'"
                    ></div>
                    <span>{{ data[indextr].note }}</span>
                  </vs-chip>
                  <vs-chip
                    v-if="data[indextr].note == 'atrasado'"
                    class="font-bold whitespace-no-wrap"
                    :data="data[indextr].note == 'atrasado'"
                  >
                    <div
                      class="h-2 w-2 rounded-full mr-1"
                      :class="'bg-primary'"
                    ></div>
                    <span>{{ data[indextr].note }}</span>
                  </vs-chip>
                  <vs-chip
                    v-if="data[indextr].note == 'trabalho de campo'"
                    class="font-bold whitespace-no-wrap"
                    :data="data[indextr].note == 'trabalho de campo'"
                  >
                    <div
                      class="h-2 w-2 rounded-full mr-1"
                      :class="'bg-primary'"
                    ></div>
                    <span>{{ data[indextr].note }}</span>
                  </vs-chip>
                  <vs-chip
                    v-if="data[indextr].note == 'antecipado'"
                    class="font-bold whitespace-no-wrap"
                    :data="data[indextr].note == 'antecipado'"
                  >
                    <div
                      class="h-2 w-2 rounded-full mr-1"
                      :class="'bg-primary'"
                    ></div>
                    <span>{{ data[indextr].note }}</span>
                  </vs-chip>
                </vs-td>
                <vs-td>
                  <vs-td class="whitespace-no-wrap" :data="data[indextr].id">
                    <vs-button
                      color="success"
                      size="small"
                      type="border"
                      @click="openEdit(tr)"
                    >
                      Editar</vs-button
                    >

                    <!-- <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" /> -->
                  </vs-td>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>

          <vs-pagination
            class="mt-3"
            :total="totalPage"
            @change="getEmployees"
            v-model="currentPage"
          ></vs-pagination>
          <div
            style="height: 50px"
            id="list-with-loading"
            class="vs-con-loading__container"
          ></div>
          <!-- <pre> {{ selected }} </pre> -->
        </div>
      </vx-card>
    </div>

    <vs-popup
      class="holamundo"
      :title="'Actualizar '"
      :active.sync="popupEditar"
    >
      <div class="vx-row">
        <div class="vx-col w-full mb-5">
          <label for="" class="font-bold">Nome: </label> {{ falta.name }}
          {{ falta.surname }}
          <vs-divider></vs-divider>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-1/2 mb-5">
          <label for="">Observação</label>
          <v-select
            v-validate="'required'"
            v-model="falta.note"
            :options="['presente', 'ausente', 'folga', 'licença']"
          >
          </v-select>
        </div>

        <div v-if="falta.note == 'presente'" class="vx-col w-1/2 mb-5">
          <label for="">Hora prevista para entrada</label>
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon-no-border
            v-model="standard_entry_time"
            type="time"
            v-validate="'required'"
          />
        </div>
      </div>
      <vs-divider>ENTRADA</vs-divider>
      <div class="vx-row">
        <div class="vx-col w-1/2 mb-5">
          <label for="">Data de entrada</label>
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon-no-border
            v-model="sub_entry_date"
            type="date"
            v-validate="'required'"
          />
        </div>
        <div class="vx-col w-1/2 mb-5">
          <label for="">Hora de Entrada</label>
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon-no-border
            v-model="sub_entry_time"
            type="time"
            v-validate="'required'"
          />
        </div>
      </div>
      <vs-divider v-if="falta.exit_date">Saida</vs-divider>
      <div v-if="falta.exit_date" class="vx-row">
        <div class="vx-col w-1/2 mb-5">
          <label for="">Data de saida</label>
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon-no-border
            v-model="sub_exit_date"
            type="date"
            v-validate="'required'"
          />
        </div>
        <div class="vx-col w-1/2 mb-5">
          <label for="">Hora de Saida</label>
          <vs-input
            class="w-full"
            icon-pack="feather"
            icon-no-border
            v-model="sub_exit_time"
            type="time"
            v-validate="'required'"
          />
        </div>
      </div>

      <div class="flex flex-wrap items-end flex-start">
        <vs-button class="ml-auto mt-2" @click="saveEdit">Actualizar</vs-button>
        <vs-button class="ml-4 mt-2" type="border" color="warning"
          >Cancelar</vs-button
        >
      </div>
    </vs-popup>
  </div>
</template>

<script>
import http from "../../../../http-common";
import vSelect from "vue-select";
export default {
  components: {
    vSelect,
  },
  data() {
    return {
      totalPage: "",
      currentPage: "",
      paginate: 50,

      /////////////////////
      dataEntrada: "",
      dataSaida: "",
      estado: "",

      err: "",
      employees: [],
      exit_date: "",
      exit_time: "",

      result: [],
      employee_id: [],
      attendance_id: [],
      standard_entry_time: "",
      entry_date: "",
      note: "",
      attachment: "",
      falta: [],
      description: "",
      name: "",
      surname: "",
      sub_entry_date: "",
      sub_entry_time: "",
      sub_exit_time: "",
      sub_exit_date: "",
      selected: [],
      func: [],
    };
  },

  mounted() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.getFunc();
      this.getEmployees();
    },

    clean() {
      (this.exit_date = ""), (this.exit_time = "");
    },

    openEdit(attendance) {
      this.falta = attendance;
      this.popupEditar = true;
      this.sub_entry_date = this.falta.entry_date.substring(0, 10);
      this.sub_entry_time = this.falta.entry_date.substring(11, 16);

      this.sub_exit_date = this.falta.exit_date.substring(0, 10);
      this.sub_exit_time = this.falta.exit_date.substring(11, 16);
    },

    saveEdit() {
      this.$vs.loading();
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };
      const data = {
        entry_date: this.sub_entry_date,
        entry_time: this.sub_entry_time,
        exit_date: this.sub_exit_date,
        exit_time: this.sub_exit_time,
        note: this.falta.note,
        type: 1,
        standard_entry_time: this.standard_entry_time,
      };
      http
        .put(
          `/attendances/attendances/${this.falta.attendance_id}`,
          data,
          config
        )
        .then((success) => {
          success;
          this.getEmployees();
          this.popupEditar = false;
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Marcações Feitas com sucesso",
            color: "success",
            position: "top-right",
          });
        })
        .catch((error) => {
          error;
          if (error.response.status == 401) {
            this.$router.push("/").catch(() => {});
          }
          if (error.response.status == 422) {
            this.err = error.response.data;
            this.$vs.notify({
              title: "Sucesso",
              text: this.err,
              color: "danger",
              position: "top-right",
            });
          } else if (error.response.status == 200) {
            this.err = error.response.data;
            console.log(this.err);
            this.$vs.notify({
              title: "Erro",
              text: this.err,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-right",
            });
          } else {
            this.$vs.loading.close();

            this.$vs.notify({
              title: "Erro",
              text: "falha ao ACtualizar",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-right",
            });
          }
        });
    },

    getFunc() {
      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
        params: {
          paginate: 10000,
          status: 1,
        },
      };

      http
        .get("/employees/employees", config)
        .then((result) => {
          this.func = result.data.Employees.data.reverse();
        })
        .catch((error) => {
          error;

          if (error.response.status == 401) {
            this.$router.push("/").catch(() => {});
          }
        });
    },

    getEmployees() {
  // Inicia o loading
  this.$vs.loading({
    container: "#list-with-loading",
    scale: 1.0,
    type: "sound",
  });

  // Configuração para timeout
  const timeout = setTimeout(() => {
    this.$vs.loading.close("#list-with-loading > .con-vs-loading");
    this.$vs.notify({
      title: "Tempo esgotado",
      text: "O servidor demorou muito para responder. Tente novamente.",
      color: "danger",
    });
  }, 15000); // 90 segundos

  let noteToSend = this.note === "licença" ? "leave" : this.note;

  let token = localStorage.getItem("token");
  let config = {
    headers: {
      authorization: "Bearer " + token,
    },
    params: {
      type: 1,
      name: this.name.name,
      surname: this.surname.surname,
      note: noteToSend,
      entry_date: this.entry_date,
      page: this.currentPage,
      paginate: this.paginate,
      status: 1,
    },
  };

  console.log("Payload enviado ao backend:", config.params);

  // Chamada ao backend
  http
    .get("/attendances/attendances", config)
    .then((result) => {
      clearTimeout(timeout); // Cancela o timeout se a resposta for recebida a tempo
      this.$vs.loading.close("#list-with-loading > .con-vs-loading");
      this.employees = result.data.Attendances.data;
      this.totalPage = result.data.Attendances.last_page;
    })
    .catch((error) => {
      clearTimeout(timeout); // Cancela o timeout mesmo em caso de erro
      this.$vs.loading.close("#list-with-loading > .con-vs-loading");
      if (error.response && error.response.status === 401) {
        this.$router.push("/").catch(() => {});
      } else {
        this.$vs.notify({
          title: "Erro",
          text: "Algo deu errado. Por favor, tente novamente.",
          color: "danger",
        });
      }
    });
},

  },
};
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }

@media screen and (min-width: 1201px) and (max-width: 1211px),
  only screen and (min-width: 636px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }
}
</style>
